export default "__VITE_ASSET__Ce7d8Tk8__"